export default __webpack_public_path__ + "static/FeatureKlimtTablet-d55a0a9990f0bf2bc8c0f3328d4cd319.png";